module.exports = __webpack_public_path__ + "static/img/服务平台-首页首图.33f26bd0.png";